import React, { useEffect, useState } from "react";
import { CustomButton, FilterBar, TableData, TxnLogView } from "../../components";
import { BugReport, MoveDown } from '@mui/icons-material';
import { useDispatch, useSelector } from "react-redux";
import { downloadDetailedReportBySalepointService, downloadDetailedReportLecarozService, downloadDetailedReportService, getCatalogsDetailedReportService, getDetailedReportService } from "../../services/report/reportService";
import { setDetailedReportFilters } from "../../redux/slices/report/reportSlice";
import { errorAlert } from "../../helpers/alerts";
import moment from "moment";
import { compareObjects, currencyFormatter, downloadFile } from "../../helpers/util";
import ColumnFilterModal from "../../components/modal/ColumnFilterModal";
import './DetailedScreen.css'
import { getLogsTxnService, getTxnBackupService } from "services/panelService";
import { setTitle } from "redux/slices/uiSlice";
import DialogModal from "../../components/modal/DialogModal";
import { Box, Table } from "@mui/material";
import { Loader } from "rsuite";
import Image from "components/common/Image";
import Images from "assets/images";
import { useLocation, useNavigate } from "react-router-dom";
import { getGroupsService } from "services/client/groupService";
import { setGroups } from "redux/slices/client/groupSlice";


const DetailedScreen = ({ network }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { detailedReportFilters } = useSelector((store) => store.reports);
  const { groups } = useSelector(store => store.group);
  const { type } = useSelector(store => store.session);
  const [operators, setOperators] = useState(null)
  const [commerces, setCommerces] = useState(null)
  const [salepoints, setSalepoints] = useState(null)
  const [credentials, setCredentials] = useState(null)
  const [segments, setSegments] = useState(null)
  const [regions, setRegions] = useState(null)
  const [detailedReport, setDetailedReport] = useState([])
  const [total, setTotal] = useState(0)
  const [showColumnFilterModal, setShowColumnFilterModal] = useState(false)
  const [loadingTable, setLoadingTable] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingLog, setLoadingLog] = useState(false)
  const [loadingLecaroz, setLoadingLecaroz] = useState(false)
  const [loadingBySalepoint, setLoadingBySalepoint] = useState(false)
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });

  const columns = [
    { category: 'Destino', name: "type", label: "Tipo", format: ({ bag }) => bag?.type },
    { category: 'Destino', name: "typeTxn", label: "Movimiento", format: ({ etagSaldo, typeReg }) => ['ABONO', 'COMISION', 'ABONO_COMISION', 'ABONO_DESCUENTO'].includes(typeReg) ? etagSaldo : ['TAE', 'PDS', 'PIN'].includes(typeReg) ? `VENTA (${typeReg})` : '-' },
    { category: 'Destino', name: "operator", label: "Operadora", format: ({ operator }) => operator },
    { category: 'Destino', name: "phone", label: "Telefono", format: ({ phoneNumber, typeReg, reference, referenceSaldo, operacionOrigen }) => (typeReg == 'PDS' || operacionOrigen) ? (reference || referenceSaldo || '-') : ['TAE', 'PIN'].includes(typeReg) ? (phoneNumber || '-') : '-' },
    { category: 'Destino', name: "segment", label: "Segmento", format: ({ productType }) => productType },
    { category: 'Destino', name: "import", label: "Importe", sort: ({ typeReg, amount, operacionSaldo }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) ? parseFloat(amount) : parseFloat(operacionSaldo), format: ({ typeReg, amount, operacionSaldo }) => currencyFormatter.format(['TAE', 'PDS', 'PIN'].includes(typeReg) ? amount : operacionSaldo) },
    { category: 'Destino', name: "reference", label: "Referencia", format: ({ typeReg, ProviderReference, referenceSaldo }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) ? ProviderReference : referenceSaldo },
    { category: 'Destino', name: "region", label: "Región", format: ({ region }) => region },
    { category: 'Saldo', name: "prevBalance", label: "Anterior", format: ({ saldoAnterior }) => saldoAnterior ? currencyFormatter.format(saldoAnterior) : '' },
    { category: 'Saldo', name: "operacionSaldo", label: "Debitado", format: ({ operacionSaldo }) => currencyFormatter.format(operacionSaldo) },
    { category: 'Saldo', name: "currentBalance", label: "Actual", format: ({ saldoActual }) => saldoActual ? currencyFormatter.format(saldoActual) : '' },
    type == 'admin' && { category: 'Saldo', name: "discount_porcent", label: "% Descuento", format: ({ discount_porcent }) => discount_porcent ? `${discount_porcent}%` : '' },
    type == 'admin' && { category: 'Saldo', name: "discount_applied", label: "Descuento", format: ({ discount_applied }) => discount_applied ? currencyFormatter.format(discount_applied) : '' },
    { category: 'Resultado', name: "state", label: "Estado", format: ({ typeReg, ProviderResponseCode }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) ? ProviderResponseCode != "00" ? 'DENEGADA' : 'APROBADA' : '' },
    { category: 'Resultado', name: "message", label: "Mensaje", format: ({ typeReg, ProviderResponseMessage, ProviderResponseCode }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) && ProviderResponseCode != '00' ? ProviderResponseMessage : '' },
    { category: 'Resultado', name: "code", label: "Codigo", format: ({ ProviderResponseCode }) => ProviderResponseCode },
    { category: 'Resultado', name: "datetime", label: "Fecha y hora", sort: ({ createdAt }) => createdAt, format: ({ createdAt }) => moment(createdAt).format('DD/MM/YYYY HH:mm:ss') },
    { category: 'Resultado', name: "auth", label: "Autorización", format: ({ AuthCode }) => AuthCode },
    { category: 'Resultado', name: "time", label: "Tiempo", format: ({ time }) => `${time} ms` },
    { category: 'Entidad', name: "commerceId", label: "ID Comercio", format: ({ commerceIdentification }) => commerceIdentification },
    { category: 'Entidad', name: "commerce", label: "Comercio", format: ({ commerce }) => commerce },
    { category: 'Entidad', name: "salepoint", label: "Punto de Venta", format: ({ salepoint }) => salepoint },
    // { category: 'Entidad', name: "bag", label: "Bolsa", format: ({ hosterBagId }) => hosterBagId.hashtag },
    type == 'admin' && { category: 'Entidad', name: "provider", label: "Proveedor", format: ({ serviceName }) => serviceName },
    { category: 'Entidad', name: "user", label: "Usuario", format: ({ user }) => user?.nameUser },
  ].filter(Boolean);
  const [selectedColumns, setSetSelectedColumns] = useState([
    "operator",
    "phone",
    "import",
    "code",
    "datetime",
  ])
  const { logs } = useSelector(store => store.reports)
  const [isModalOpen, setIsModalOpen] = useState(false)

  useEffect(() => {
    dispatch(setTitle('Reporte Detallado'));
    getGroupsService()
      .then((response) => dispatch(setGroups(response)))
      .catch((e) => errorAlert(e))
    // eslint-disable-next-line
    return () => {
      dispatch(setDetailedReportFilters(null))
    }
  }, []);
  console.log('network', network);

  useEffect(() => {
    if (isModalOpen && logs.length > 0) {
      let logsWin = window.open("about:blank", "logs", "width=640,height=320");
      logs.map(({ uuid, date, message }) => {
        logsWin.document.write(uuid + " " + date + " " + message + "<br/>");
      });
      setIsModalOpen(false);
    }
  }, [isModalOpen, logs]);

  const handlerSubmit = async (data) => {
    if (location.state) {
      data = location.state;
      navigate(location.pathname, { replace: true, state: null });
    }
    const selectedDates = {
      start: moment(data.date[0]).format('YYYY-MM-DD'),
      end: moment(data.date[1]).format('YYYY-MM-DD')
    }
    const currentDates = {
      start: detailedReportFilters && moment(detailedReportFilters.date[0]).format('YYYY-MM-DD'),
      end: detailedReportFilters && moment(detailedReportFilters.date[1]).format('YYYY-MM-DD')
    }
    if (selectedDates.start !== currentDates.start || selectedDates.end !== currentDates.end || operators == null) {
      setOperators(null)
      getCatalogsDetailedReportService('operators', data).then((data) => {
        setOperators(data)
      })
    }
    if (selectedDates.start !== currentDates.start || selectedDates.end !== currentDates.end || operators == null) {
      setOperators(null)
      getCatalogsDetailedReportService('segments', data).then((data) => {
        setSegments(data)
      })
    }
    if (selectedDates.start !== currentDates.start || selectedDates.end !== currentDates.end || operators == null) {
      setOperators(null)
      getCatalogsDetailedReportService('regions', data).then((data) => {
        setRegions(data)
      })
    }
    if (selectedDates.start !== currentDates.start || selectedDates.end !== currentDates.end || commerces == null) {
      setCommerces(null)
      getCatalogsDetailedReportService('hosters', data).then((data) => setCommerces(data.sort((a, b) => a.order - b.order)))
    }
    if (selectedDates.start !== currentDates.start || selectedDates.end !== currentDates.end || credentials == null) {
      setCredentials(null)
      getCatalogsDetailedReportService('credentials', data).then((data) => setCredentials(data))
    }
    if (selectedDates.start !== currentDates.start || selectedDates.end !== currentDates.end || salepoints == null) {
      setSalepoints(null)
      getCatalogsDetailedReportService('salepoints', data).then((data) => setSalepoints(data))
    }
    if (!compareObjects(data, detailedReportFilters)) {
      dispatch(setDetailedReportFilters(data))
    }
    setLoadingTable(true)

    getDetailedReportService(selectedColumns, {
      ...data,
      network,
      page,
      limit,
      withTime: true
    }).then((result) => {
      setDetailedReport(result.data)
      setTotal(result.total)
      if (detailedReportFilters?.type != data.type && data.type == 2)
        setSetSelectedColumns(['type', 'import', 'reference', 'datetime', 'commerce', 'user'])
      else if (detailedReportFilters?.type != data.type)
        setSetSelectedColumns(["operator", "phone", "import", "code", "datetime"])
    }).catch((error) => errorAlert(error))
      .finally(() => setLoadingTable(false));
  }

  const handlerDownload = async () => {
    setLoading(true)
    downloadDetailedReportService(selectedColumns, detailedReportFilters)
      .then((data) => downloadFile(data, 'Reporte Detallado.xlsx'))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false));
  }
  const handlerDownloadLecaroz = async () => {
    setLoadingLecaroz(true)
    downloadDetailedReportLecarozService(selectedColumns, detailedReportFilters)
      .then((data) => downloadFile(data, 'Reporte Detallado.xlsx'))
      .catch((e) => errorAlert(e))
      .finally(() => setLoadingLecaroz(false));
  }
  const handlerDownloadBySalepoint = async () => {
    setLoadingBySalepoint(true)
    downloadDetailedReportBySalepointService(selectedColumns, detailedReportFilters)
      .then((data) => downloadFile(data, 'Reporte por Sucursal.xlsx'))
      .catch((e) => errorAlert(e))
      .finally(() => setLoadingBySalepoint(false));
  }

  const handlerSelectColumn = (columns) => {
    setSetSelectedColumns(columns)
    setShowColumnFilterModal(false)
  }
  const [page, setPage] = useState(0)
  const [limit, setLimit] = useState(25)

  return (
    <>
      <Box
        bgcolor={'#FFFFFF'}
        pt={1}
        pb={2}
        px={4}
        mx={-4}
        mt={-2}
        mb={2}
      >
        <FilterBar
          handlerFilter={handlerSubmit}
          page={page}
          limit={limit}
          showButton={true}
          defaultValues={{
            type: 1,
            date: [
              moment().startOf('day').toDate(),
              moment().endOf('day').toDate()
            ],
          }}
          allValue={null}
          filters={[
            {
              type: "dates",
              name: "date",
              label: "Fecha",
              format: "dd/MM/yyyy HH:mm",
            },
            {
              name: 'type',
              label: "Tipo de Movimiento",
              type: "select",
              all: 'Todos',
              data: [
                { id: 1, name: "Venta" },
                { id: 2, name: "Abonos" },
              ],
            },
            {
              name: 'typeReg',
              label: "Tipo de Venta",
              type: "select",
              all: 'Todos',
              data: [
                { id: 'TAE', name: "Tiempo Aire" },
                { id: 'PDS', name: "Pago de Servicios" },
                { id: 'PIN', name: "Tarjetas de Regalo" },
              ],
            },
            {
              name: "state",
              label: "Estado",
              type: "select",
              all: 'Todos',
              data: [
                { id: 1, name: "Aprobadas" },
                { id: 2, name: "Denegadas" },
              ],
            },
            {
              name: "operator",
              label: "Operadora",
              type: "select",
              all: 'Todas',
              data: operators || [],
              loading: operators == null
            },
            {
              name: "segment",
              label: "Segmento",
              type: "select",
              all: 'Todos',
              data: segments || [],
              loading: segments == null
            },
            {
              name: "region",
              label: "Región",
              type: "select",
              all: 'Todas',
              data: regions || [],
              loading: regions == null
            },
            {
              name: 'group',
              label: "Grupo",
              type: "select",
              all: 'Todos',
              data: groups || [],
              loading: groups == null

            },
            {
              name: 'commerce',
              label: "Comercio",
              type: "select",
              all: 'Todos',
              data: commerces || [],
              loading: commerces == null
            },
            // {
            //   name: 'bag',
            //   label: "Bolsa",
            //   type: "select",
            //   all: 'Todas',
            //   data: bags,
            // },
            {
              name: 'salepoint',
              label: "Punto de Venta",
              type: "select",
              all: 'Todas',
              data: salepoints || [],
              loading: salepoints == null

            },
            type == 'admin' && {
              name: 'credential',
              label: "Proveedor",
              type: "select",
              all: 'Todas',
              data: credentials || [],
              loading: credentials == null

            },
            type == 'admin' && {
              name: 'backup',
              label: "Respuesta Proveedor Backup",
              type: "select",
              all: 'Ambas',
              data: [
                { id: 1, name: "Si" },
                { id: 2, name: "No" },
              ],
            },

          ]}
        />
      </Box>
      <TableData
        filters={detailedReportFilters}
        loading={loadingTable}
        sorteable={true}
        defaultOrderBy={"datetime"}
        onChangePage={setPage}
        onChangeRowsPerPage={setLimit}
        sorteableData={data => data.map(item => {
          columns.filter(({ name }) => selectedColumns.includes(name)).map(({ name, format, sort }) => item[`_${name}_`] = sort ? sort(item) : format(item))
          return item
        })}
        total={total}
        dataRows={detailedReport.map((item) => ({
          ...item,
          style: item.ProviderResponseCode != "00" && ['TAE', 'PDS', 'PIN'].includes(item.typeReg) && { color: 'red' }
        }))}
        headerButtons={[
          <CustomButton
            dark={true}
            icon={<Image src={Images.icon.columnas} />}
            key="filterColumns"
            name={"Columnas"}
            click={() => setShowColumnFilterModal(true)}
          />,
          <CustomButton
            dark={true}
            icon={Images.icon.download}
            key="dowloadDetails"
            name={"Descargar"}
            loading={loading}
            click={handlerDownload}
          />,
          type == 'admin' && <CustomButton
            dark={true}
            icon={Images.icon.download}
            key="dowloadDetailsLecaroz"
            name={"Lecaroz"}
            loading={loadingLecaroz}
            click={handlerDownloadLecaroz}
          />,
          <CustomButton
            dark={true}
            icon={Images.icon.download}
            key="downloadBySalepoint"
            name={"Por Sucursal"}
            loading={loadingBySalepoint}
            click={handlerDownloadBySalepoint}
          />,
        ]}
        dataTitle={columns.filter(({ name }) => selectedColumns.includes(name))}
        formatter={(data) => columns.filter(({ name }) => selectedColumns.includes(name)).map(({ format }) => format(data))}
        actions={[
          type == 'admin' && {
            label: "Logs",
            icon: (data) => loadingLog == data._id ? <Loader size="xs" /> : <BugReport />,
            validate: () => type == 'admin',
            onClick: async (data) => {
              setLoadingLog(data._id)
              const result = await getLogsTxnService(data._id);
              setLoadingLog(false)
              setDialog({
                open: true,
                maxWidth: 'lg',
                title: `Log Transacción ${data._id}`,
                textAlign: 'left',
                body: <TxnLogView data={result} />,
                onClose: () => setDialog({ open: false })
              })
            },
          },
          type == 'admin' && {
            label: "Backup",
            icon: <MoveDown />,
            validate: (data) => type == 'admin' && data.redirectToBackup,
            onClick: async (data) => {
              const result = await getTxnBackupService(data._id);
              setDialog({
                open: true,
                title: "Respuesta Proveedor Primario",
                body: <>
                  <Table>
                    <tbody>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <b>Proveedor</b>
                        </td>
                        <td style={{ width: '50%' }}>
                          {result.primaryProvider}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <b>Mensaje</b>
                        </td>
                        <td style={{ width: '50%' }}>
                          {result.primaryProviderResponseMessage}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <b>Código</b>
                        </td>
                        <td style={{ width: '50%' }}>
                          {result.primaryProviderResponseCode}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <b>Tiempo de respuesta</b>
                        </td>
                        <td style={{ width: '50%' }}>
                          {result.primaryProviderResponseTime.toFixed(2)} s
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <h4 style={{
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    fontSize: '1.20rem',
                    lineHeight: 1.6,
                    padding: 10,
                    margin: '20px 0',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
                  }}>Respuesta Proveedor Backup</h4>
                  <Table>
                    <tbody>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <b>Proveedor</b>
                        </td>
                        <td style={{ width: '50%' }}>
                          {result.serviceName}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <b>Mensaje</b>
                        </td>
                        <td style={{ width: '50%' }}>
                          {result.ProviderResponseMessage}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <b>Código</b>
                        </td>
                        <td style={{ width: '50%' }}>
                          {result.ProviderResponseCode}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ width: '50%' }}>
                          <b>Tiempo de respuesta</b>
                        </td>
                        <td style={{ width: '50%' }}>
                          {(((result.endTxn || result.updatedAt) - result.createdAt) / 1000).toFixed(2)} s
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </>,
                onClose: () => setDialog({ open: false })
              })
            },
          },
        ]}
      />
      <ColumnFilterModal
        open={showColumnFilterModal}
        columns={columns}
        report={'detailed'}
        selected={selectedColumns}
        onSuccess={handlerSelectColumn}
        onClose={() => setShowColumnFilterModal(false)}
      />
      <DialogModal
        open={dialog.open}
        title={dialog.title}
        body={dialog.body}
        maxWidth={dialog.maxWidth}
        textAlign={dialog.textAlign}
        onSuccess={dialog.onSuccess}
        onClose={dialog.onClose}
      />
    </>
  );
};

export default DetailedScreen;
